import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

import { T } from "components/util/t";
import { mergeSx, Sx } from "utils/sx";

const styles: Sx = (theme) => ({
    alignItems: "center",
    textAlign: "center",
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "center",
    left: theme.spacing(0),
    maxWidth: "100vw",
    paddingX: theme.spacing(1),
    position: "sticky",
    top: theme.spacing(0),
    whiteSpace: "pre",
    width: "calc(100vw - (100vw - 100%))",
    zIndex: 6,
});

const infoTypeStyles: Sx = (theme) => ({
    background: theme.palette.background.dark,
    color: theme.palette.text.contrastText,
});

const successTypeStyles: Sx = (theme) => ({
    background: theme.palette.success.main,
    color: theme.palette.text.primary
});

const warnTypeStyles: Sx = (theme) => ({
    background: theme.palette.warn.light,
});

const typographyStyles: Sx = (_theme) => ({
    textWrap: "wrap",
});

const titleStyles: Sx = (theme) => ({
    fontWeight: theme.typography.fontWeightBold,
});

type ActionNotificationStickyType = "info" | "success" | "warn";

const typeToStyles: Record<ActionNotificationStickyType, Sx> = {
    info: infoTypeStyles,
    success: successTypeStyles,
    warn: warnTypeStyles,
};

type ActionNotificationStickyProps = {
    icon?: ReactNode;
    text: string | ReactNode;
    title?: string;
    type?: ActionNotificationStickyType;
    size?: "small" | "medium";
};

const sizesStyles: Record<"small" | "medium", Sx> = {
    small: { paddingY: 0.5 },
    medium: { paddingY: 1 }
};

export const ActionNotificationSticky = ({
    icon,
    text,
    title,
    type = "info",
    size = "small",
}: ActionNotificationStickyProps) => {
    return (
        <Box sx={mergeSx(styles, typeToStyles[type], sizesStyles[size])} role="alert">
            {icon}
            <Typography sx={typographyStyles} variant="body1">
                {title && (
                    <Typography component="span" sx={titleStyles}>
                        <T data-testid={`action-notification-sticky.title.${type}`}>{title}</T>{" "}
                    </Typography>
                )}
                <T data-testid={`action-notification-sticky.text.${type}`}>{text}</T>
            </Typography>
        </Box>
    );
};
